import {forwardRef, SVGProps} from 'react';

// eslint-disable-next-line react/display-name
export const SelfAssessIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) =>
	<svg
		width='28'
		height='28'
		viewBox='0 0 28 28'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
		ref={ref}
	>
		<circle cx='14.0385' cy='14.0385' r='12' fill='white'/>
		<path d='M21.5258 21.5385H6.55112C6.78049 17.0267 10.0946 13.5385 14.0385 13.5385C17.9823 13.5385 21.2964 17.0267 21.5258 21.5385Z' fill='#BA5ACB' stroke='white'/>
		<circle cx='14.0385' cy='10.0385' r='5' fill='#FFA53D' stroke='white' strokeWidth='2'/>
		<circle cx='14' cy='14' r='13' stroke='#059BE0' strokeWidth='2'/>
	</svg>
);
